import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";

import { DevicePreview, Form } from "@shared/components";

export function CustomizationFields() {
  const translate = useTranslate();

  return (
    <Grid container spacing={5}>
      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker
          name="logo"
          label={translate("v1/agreement_admin.fields.logo")}
          size={150}
          shape="square"
        />
      </Grid>

      <Grid container spacing={3} size={{ xs: 12 }}>
        <Grid size={{ xs: 6 }}>
          <Form.ColorPickerInput
            name="menu_color"
            label={translate("v1/agreement_admin.fields.menu_color")}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <Form.ColorPickerInput
            name="menu_font_color"
            label={translate("v1/agreement_admin.fields.menu_font_color")}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <Form.ColorPickerInput
            name="primary_color"
            label={translate("v1/agreement_admin.fields.primary_color")}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <Form.ColorPickerInput
            name="primary_font_color"
            label={translate("v1/agreement_admin.fields.primary_font_color")}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <Form.ColorPickerInput
            name="secondary_color"
            label={translate("v1/agreement_admin.fields.secondary_color")}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <Form.ColorPickerInput
            name="secondary_font_color"
            label={translate("v1/agreement_admin.fields.secondary_font_color")}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Form.Switch
            name="in_app_landing"
            label={translate("v1/agreement_admin.fields.in_app_landing")}
          />
        </Grid>
      </Grid>

      <Grid size={{ xs: 6 }}>
        <DevicePreview />
      </Grid>
    </Grid>
  );
}
